export default __webpack_public_path__ + "static/media/Curvet7.5.48df33b5.svg";